import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "../../sidebar.css";

function RightSidebarCategory({ isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const { menuSubMenus } = useSelector((state) => state.menu);
  const [activeMenu, setActiveMenu] = useState(null);

  // ✅ Prevent scrolling when sidebar is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling
      document.body.style.height = "100vh"; // Prevent body from scrolling
    } else {
      document.body.style.overflow = "auto"; // Restore scrolling
      document.body.style.height = "auto"; // Restore height
    }
  }, [isOpen]);

  const toggleSubMenu = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  const handleNavigateUrl = (url) => {
    setIsOpen(false);
    navigate(url);
  };

  return (
    <>
      {/* ✅ Full-screen overlay when sidebar is open */}
      {isOpen && (
        <div className="overlay" onClick={() => setIsOpen(false)}></div>
      )}

      {/* ✅ Sidebar */}
      <div className={`sidebar custom-scrollbar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h6 className={"m-0 text-white"}>CATEGORIES</h6>
          <button
            className="sidebar-close-btn"
            onClick={() => setIsOpen(false)}
          >
            <i className={"fa fa-close"}></i>
          </button>
        </div>

        <ul className="menu">
          {menuSubMenus?.map((menu, index) => (
            <li key={index}>
              <span className="category" onClick={() => toggleSubMenu(index)}>
                <button
                  style={{ fontWeight: "500", fontSize: 16 }}
                  onClick={() =>
                    handleNavigateUrl(`/category/${menu.slug_url}`)
                  }
                >
                  {menu.name}
                </button>
                {menu.subMenu.length > 0 && (
                  <span className="icon">
                    {activeMenu === index ? (
                      <i className={"fa fa-chevron-up"}></i>
                    ) : (
                      <i className={"fa fa-chevron-down"}></i>
                    )}
                  </span>
                )}
              </span>
              {activeMenu === index && menu.subMenu.length > 0 && (
                <div className="sub-category-container">
                  <ul className="sub-category">
                    {menu.subMenu.map((subMenu, subIndex) => (
                      <li key={subIndex} style={{ borderBottom: "unset" }}>
                        <button
                          onClick={() =>
                            handleNavigateUrl(
                              `/category/${menu.slug_url}/${subMenu.slug_url}`,
                            )
                          }
                        >
                          {subMenu.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default RightSidebarCategory;
